import React from "react";
import ClassStudentFeeSummary from "./ClassStudentFeeSummary";

const TotalSettled = () => (
  <ClassStudentFeeSummary
    title="Total Settled"
    metricKey="due_settlement"
    metricLabel="Settled"
    accentColor="#3b82f6"
    showOnlyPositive
  />
);

export default TotalSettled;
